import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const downloadAgent = async (os) => {
  const token = sessionStorage.getItem('authToken');
  if (!token) {
    throw new Error('Your session has expired. Please sign in and try again.');
  }

  const encodedOS = encodeURIComponent(os);
  const endpoint = `${api_base_url}/api/${api_key}/downloads/${encodedOS}`;
  const response = await fetch(`${endpoint}/ticket`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.error || `Agent download failed (${response.status}).`);
  }

  const payload = await response.json();
  if (!payload?.ticket || !payload?.fileName) {
    throw new Error('The server did not return a valid installer download.');
  }

  const downloadUrl = `${endpoint}?ticket=${encodeURIComponent(payload.ticket)}`;
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', payload.fileName);
  link.setAttribute('referrerpolicy', 'no-referrer');
  document.body.appendChild(link);
  link.click();
  link.remove();

  return payload.fileName;
};
